<template>
<div class="member-tag">
        <span class="member-container">
            <div class="member-name">{{ data.memberName }}</div>
            <svg-icon name="header-file_transfer_delete" class="delete-icon" @click.stop="deleteMember(data)"></svg-icon>
        </span>
    </div>
</template>

<script lang="ts">
export default {
    name: 'MemberTag',
    props: {
        data: {
            type: Object,
        }
    },
    emits: ['deleteMember'],
    methods: {
        deleteMember(data: any) {
            this.$emit('deleteMember', data);
        }
    }
}
</script>

<style lang="scss" scoped>
.member-tag {
    height: 24px;
    background: #FFFFFF;
    border-radius: 4px;
    text-align: center;
    margin-left: 12px;
    .member-container {
        padding: 2px 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        .member-name {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #121317;
            line-height: 20px;
            margin-right: 4px;
        }

        .delete-icon {
            width: 10px;
            height: 10px;
            cursor: pointer;
        }
    }
}
</style>
